import React from "react";

// Решение клиента (20.07.2026): анкеты доступны и в DEMO-играх.
// Раньше HOC редиректил назад для game.type === "DEMO", из-за чего купленную
// в демо-игре пустую анкету нельзя было открыть (списание было, продукта не
// было). Гейт снят; обёртка сохранена, чтобы не трогать 7 страниц-потребителей
// и иметь точку для будущих ограничений.
export default function InsightFormProtect(Component) {
  return function AuthenticatedComponent(props) {
    return <Component {...props} />;
  };
}
